import { render, staticRenderFns } from "./process.vue?vue&type=template&id=39070f0f&scoped=true"
import script from "./process.vue?vue&type=script&lang=js"
export * from "./process.vue?vue&type=script&lang=js"
import style0 from "./process.vue?vue&type=style&index=0&id=39070f0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39070f0f",
  null
  
)

export default component.exports